import { Component, OnInit } from '@angular/core';
import { FireAssessmentService } from 'src/app/services/fire-assessment.service';
import { ActivatedRoute, Router } from '@angular/router'; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common'; // Location service is used to go back to previous component
import * as html2pdf from 'html2pdf.js';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
//Dre Imports for Chart
import { assessmentApiEndpoint } from 'src/app/consts/conts.global';
import { HttpClient } from '@angular/common/http';
import { delay, filter, first, tap } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { of } from 'rxjs';
import { AuthService } from 'src/app/shared/service/auth.service';

interface ImplementationStatus {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-views',
  templateUrl: './views.component.html',
  styleUrls: ['./views.component.scss'],
})
export class ViewsComponent implements OnInit {
  probSolvStat: string;
  teamExecutionStat: string;
  industryCondStat: string;

  statResp: ImplementationStatus[] = [
    { value: 'no', viewValue: 'No' },
    { value: 'yes', viewValue: 'Yes' },
  ];

  //implement Read More
  isReadMore = true;
  pendingData = true;

  showTxtDescription = true;
  
  showTxt() {
    this.showTxtDescription = !this.showTxtDescription;
  }

  constructor(
    public fireAssessment: FireAssessmentService,

    private router: Router,
    private location: Location,
    private actRoute: ActivatedRoute,
    private guard: AuthGuard,
    private firestoredb: AngularFirestore,
    private http: HttpClient,
    public authService: AuthService
  ) {}

  //declare form variable here

  data!: any;
  public excellent: string = 'Excellent';
  public good: string = 'Good';
  public average: string = 'Average';
  public belowAverage: string = 'Below Average';
  public poor: string = 'Poor';
  public actionItemForm: FormGroup;

  //Chart data
  revModel!: any;
  revInitialCapital!: number;
  revStartingCosts!: number;
  revPerUser!: number;
  revCOGS!: number;
  revFixedCostPerMonth!: number;
  revInitUsers!: number;
  revMonthlyUserGrowth!: number;
  revMonthlyUserLoss!: number;

  B2BValueCopy!: number;
  B2CValueCopy!: number;

  assessmentPayload: any;
  assessmentDate: any;

  
  ngOnInit(): void {
    //this.barriersLeftArray();
     const id = this.actRoute.snapshot.paramMap.get('id');
    this.getAssessmentData(id);
    this.loadData();
   
  }

  retrieveRecommandationText(property: string): string {
    const recommendation = this.assessmentPayload?.userAssessmentRecommandations?.find(
      (rec: any) => rec?.hasOwnProperty(property) && rec[property]
    );
    return (recommendation && recommendation[property]) || '';
  }

  assessmentInput: any;
  getAssessmentData(id: string) {
    //define all variables of a single assessment
    this.firestoredb
      .collection('assessment-results')
      .doc(id)
      .snapshotChanges()
      .pipe(filter((data) => data.payload.exists))
      .subscribe((data: any) => {
        this.assessmentPayload = data.payload.data();
        this.pendingData = false;
      });
    this.assessmentInput = this.fireAssessment
      .readSustainibleAssessment(`${id}`)
      .get()
      .toPromise()
      .then((snapshot) => this.data = snapshot.data());
  }

  goBack() {
    this.location.back();
  }

  exportOnClick() {
    const options = {
      filename: 'Sustainible_Recommendations.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
      margin: 12,
      pagebreak: { mode: 'avoid-all' },
    };

    const content: Element = document.getElementById('element-to-export');

    html2pdf().from(content).set(options).save();
  }

  public show: boolean = true;
  public hide: boolean = false;

  toggle() {
    this.show = !this.show;
    this.hide = !this.hide;
  }

  //Just testing the PMF function
  
  /*pmfSolveNeedRate() {
    debugger
    let solveNeedPoints = 0;
    let additionalpoints = 0;
     let totalpoints = 0;
     let missingpoints = 0;
     let biggestArray: number;
     let smallestArray: number;
     let solveNeedPercentage = 0;
   

    if (this.pmfCompetitorDissatisfactionNameArray.length >
      this.offerDifferentiationNameArray.length
    ) {
      biggestArray = this.pmfCompetitorDissatisfactionNameArray.length;
      smallestArray = this.offerDifferentiationNameArray.length;
    } else {
      biggestArray = this.offerDifferentiationNameArray.length;
      smallestArray = this.pmfCompetitorDissatisfactionNameArray.length;
    }

    if (biggestArray == this.offerDifferentiationNameArray.length) {
    for (let i = 0; i < biggestArray; i++) {//biggest then smallest worked wehn offer was biggest 
        for (let j = 0; j < smallestArray; j++) {
          if (this.offerDifferentiationNameArray[i].name == this.pmfCompetitorDissatisfactionNameArray[j].name) {
            solveNeedPoints++;
        } 
    } 
  }  
} else {
  for (let i = 0; i < smallestArray; i++) {
    for (let j = 0; j < biggestArray; j++) {
      if (this.offerDifferentiationNameArray[i].name == this.pmfCompetitorDissatisfactionNameArray[j].name) {
        solveNeedPoints++;
    } 
} 
}  
}
   additionalpoints = this.offerDifferentiationNameArray.length - solveNeedPoints; 
   missingpoints = this.pmfCompetitorDissatisfactionNameArray.length - solveNeedPoints;
   totalpoints = additionalpoints + (solveNeedPoints*2) - missingpoints;
   
   if (totalpoints < 0 && additionalpoints > 0) {
      totalpoints = (additionalpoints*.25); //to give some credit
    } else if (totalpoints < 0 && additionalpoints <= 0) {
    totalpoints = 0;
  }

//additional customers may not want it but its a bonus
//matched is great!
//missing is 1
    const solveNeedRate =
    totalpoints / (this.pmfCompetitorDissatisfactionNameArray.length*2);
    
    if (solveNeedRate > 1) {
      solveNeedPercentage = 100;
    } else {
    solveNeedPercentage = Math.round(solveNeedRate * 100);
    }
    return { solveNeedRate, solveNeedPercentage };
  }*/


 barriersLeftArray()  {
   debugger
    let existingBarriersFullArray = [];
    let teamtoGetArray = [];
    let existingBarriersNameArray = [];
    const teamUnadvNameArray = [
      { value: 1, name: 'Tech Challenges' },
      { value: 1, name: 'Selling enough to make money on each (Economies of Scale)' },
      { value: 1, name: 'Government Regulation (Licensing, permits, etc.)', },
      { value: 1, name: 'Startup costs/Access to capital' },
    ];
    const offerMarkBarNameArray =  [
      { value: 1, name: 'Tech Challenges' },
      { value: 1, name: 'Government Regulation (Licensing, permits, etc.)', },
      { value: 1, name: 'Startup costs/Access to capital' },
      { value: 1, name: 'High research and development costs' },
      { value: 1, name: 'Ownership of Raw Materials' },
      { value: 1, name: 'Business Owner Education or Skills' },
      { value: 1, name: 'Personal Network, it`s about who you know' },
      { value: 1, name: 'Selling enough to make money on each (Economies of Scale)' },
      { value: 1, name: 'Network Effect, Sales' },
      { value: 1, name: 'Brand loyalty' },
      { value: 1, name: 'Access to suppliers and distribution channels' },
      { value: 0, name: 'None of the above' },
    ];

  
    teamtoGetArray = teamUnadvNameArray.filter((x: { name: any; }) => !offerMarkBarNameArray.find(rm => (rm.name === x.name)));
    existingBarriersFullArray = offerMarkBarNameArray.filter((x: { name: any; }) => !teamUnadvNameArray.find(rm => (rm.name === x.name)));
    for (let i = 0; i < existingBarriersFullArray.length; i++) {
      existingBarriersNameArray.push(existingBarriersFullArray[i].name)
    }

 /*  for (let i = 0; i < offerMarkBarNameArray.length; i++) {// biggest then smallest worked wehn offer was biggest
     for (let j = 0; j < teamUnadvNameArray.length; j++) {
         if (offerMarkBarNameArray[i].name != teamUnadvNameArray[j].name) { 
         if (teamUnadvNameArray[j].name != "None of the above"){
          existingBarriersArrayDuplicate.push(offerMarkBarNameArray[i].name);
         }
        }
      }
  }*/
 /* existingBarriersArray = existingBarriersArrayDuplicate.filter(function(elem, index, self) {
    return index === self.indexOf(elem);
})*/

    //return existingBarriersArray;
  };


  // Business section code
  isEditable: boolean = false;
  text: any = document.getElementById('myText');
  myData: any;
  postData: any = window.localStorage.getItem('save');

  // Turns contenteditable to true and hides the edit button after click
  toggleEdit() {
    this.isEditable = true;
  }

  // Doesn't save changes reveals edit button again and hides save and cancel buttons
  cancelEdit() {
    this.isEditable = false;
  }
  // Code from https://jsfiddle.net/zrd86n2v/4/
  // These functions are connected to the business section HTML at the end and connected to buttons

  // Supposed to load saved text, need to connect to database
  loadData() {
    // if no data
    if (this.postData == null || this.postData == '') {
      this.myData = this.text?.innerHTML;
      // store default value
      window.localStorage.setItem('save', this.myData);
      // make it placeholder style
      this.text?.classList.remove('changed');
    } else  if (this.text) {
      // if there is a value post it
      this.text.innerHTML = this.postData;
      // make dark text
      this.text.classList.add('changed');
    }
  }

  // Saves changes and reveals edit button while hiding save and cancel buttons on click
  saveEdit() {
    this.isEditable = false;
    // store the current value
    this.myData = this.text.innerHTML;
    // local store the value
    window.localStorage.setItem('save', this.myData);
    this.text.classList.add('changed');
  }
}
